import React, { useState } from "react";
import { Select, Card, Tag, Typography, Flex, Rate } from "antd";
import hotelImage from "../assets/images/hotelCategory.jpg";
import hotelCategoryTwo from "../assets/images/hotelCategoryTwo.jpg";

const { Text, Paragraph, Title } = Typography;

const HotelCategoryChoose = () => {
  const packages = [
    {
      id: 1,
      title: "Mountain Glamping Resort & Bishkek",
      subTitle: " RESORT | 2 Nights in Krabi",
      hotelDetail:
        "With friendly service, a relaxing ambiance, and convenient access to Yerevan’s cultural attractions, Orbeli.",
      image: hotelImage,
      checkIn: "June 8, 2:00 PM",
      checkOut: "June 10, 11:00 AM",
      includes: [
        "Direct flights from Sharjah/Abu Dhabi/Dubai",
        "Hotel stay in Bishkek with breakfast",
        "One night stay at Yurt in Supara Resort",
        "Airport welcome & on-ground support by Holiday Factory guide",
        "Return airport-hotel transfers",
        "4×4 Jeep transfers between Bishkek and Supara Resort",
        "Travel Insurance of Schengen standard",
      ],
      extras: ["Complimentary archery", "10% discount on horseback riding"],
      prices: [
        {
          handBaggage: "Hand Baggage only (10kg)",
          pricesDetails: [
            { id: "price1", nights: 3, price: 1899, active: true },
            { id: "price2", nights: 4, price: 2099 },
            { id: "price3", nights: 5, price: 2199 },
          ],
        },
        {
          handBaggage: "Hand Baggage only (30kg)",
          pricesDetails: [
            { id: "price4", nights: 3, price: 1899, active: true },
            { id: "price5", nights: 4, price: 2099 },
            { id: "price6", nights: 5, price: 2199 },
          ],
        },
      ],
    },
    {
      id: 2,
      title: "Glamping Resort & Bishkek",
      subTitle: " RESORT | 2 Nights in Krabi",
      hotelDetail:
        "With friendly service, a relaxing ambiance, and convenient access to Yerevan’s cultural attractions, Orbeli.",
      image: hotelCategoryTwo,
      checkIn: "June 8, 2:00 PM",
      checkOut: "June 10, 11:00 AM",
      includes: [
        "Direct flights from Sharjah/Abu Dhabi/Dubai",
        "Hotel stay in Bishkek with breakfast",
        "One night stay at Yurt in Supara Resort",
        "Airport welcome & on-ground support by Holiday Factory guide",
        "Return airport-hotel transfers",
        "4×4 Jeep transfers between Bishkek and Supara Resort",
        "Travel Insurance of Schengen standard",
      ],
      extras: ["Complimentary archery", "10% discount on horseback riding"],
      prices: [
        {
          handBaggage: "Hand Baggage only (10kg)",
          pricesDetails: [
            { id: "price7", nights: 3, price: 1899, active: true },
            { id: "price8", nights: 4, price: 2099 },
            { id: "price9", nights: 5, price: 2199 },
          ],
        },
        {
          handBaggage: "Hand Baggage only (30kg)",
          pricesDetails: [
            { id: "price10", nights: 3, price: 1899, active: true },
            { id: "price11", nights: 4, price: 2099 },
            { id: "price12", nights: 5, price: 2199 },
          ],
        },
      ],
    },
  ];
  const [selectedPrices, setSelectedPrices] = useState({});
  return (
    <div className="container">
      {/* HEADER */}

      <Title className="!font-medium !text-danger !text-3xl !mb-1" level={2}>
        <span className="text-primary">Choose your hotel </span> category here
      </Title>

      <Paragraph className="font-medium">
        Culture, nature, thrills, and record-breaking experiences
      </Paragraph>

      <Select
        placeholder="Select your Airline"
        className="roundCornersSelect mx-auto w-[90%] lg:max-w-[50%] my-8"
        size="large"
        style={{ borderRadius: 20 }}
      />

      {/* PACKAGE CARDS */}
      {packages.map((pkg) => (
        <div
          key={pkg.id}
          className="grid lg:grid-cols-2 gap-6 items-start pt-6"
        >
          {/* IMAGE SECTION */}
          <Card
            className="imageCoverPage relative overflow-hidden rounded-xl shadow-md p-0 border-0 h-full"
            styles={{
              body: {
                padding: 0,
              },
            }}
            cover={
              <div
                className="relative bg-cover bg-center rounded-xl h-full object-cover"
                style={{ backgroundImage: `url(${pkg.image})` }}
              >
                <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(6,6,6,0)_35.35%,rgba(0,0,0,0.75)_68.09%)] rounded-xl"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg font-semibold">{pkg.title}</h3>
                  <h3 className="text-lg font-semibold">{pkg.subTitle}</h3>

                  <Paragraph className="text-white font-medium mt-3">
                    {pkg.hotelDetail}
                  </Paragraph>

                  {/* Rating Badge */}
                  <div>
                    <Flex align="center" className="mt-2">
                      <Rate
                        tooltips={"desc"}
                        onChange={() => {}}
                        value={"4.5"}
                      />
                      <div className="text-xs font-medium">4.9 (523)</div>
                    </Flex>
                  </div>
                </div>
              </div>
            }
          />

          {/* PACKAGE DETAILS */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Package includes:</h3>
            <ul className="list-disc ml-5 space-y-1 font-medium text-sm">
              {pkg.includes.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <h3 className="text-lg font-semibold mt-4 mb-1">Extras:</h3>
            <ul className="list-disc ml-5 text-sm text-gray-700 space-y-1">
              {pkg.extras.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {/* PRICE ROW */}
          <div className="lg:col-span-2 flex flex-wrap gap-3">
            {pkg.prices.map((priceGroup) => (
              <div key={priceGroup.handBaggage}>
                <p className="font-semibold mb-2">{priceGroup.handBaggage}</p>
                <div className="flex flex-wrap gap-3">
                  {priceGroup.pricesDetails.map((p) => {
                    const isSelected = selectedPrices[pkg.id] === p.id;
                    return (
                      <div
                        key={p.id}
                        onClick={() =>
                          setSelectedPrices((prev) => ({
                            ...prev,
                            [pkg.id]: p.id,
                          }))
                        }
                        className={`w-36 pl-4 py-2 rounded-xl cursor-pointer transition-colors duration-200 ${
                          isSelected
                            ? "bg-[#C10707] text-white"
                            : "bg-[#F7EAB0] text-gray-800"
                        }`}
                      >
                        <p className="font-semibold">INR {p.price}</p>
                        <p className="text-xs font-medium">{p.nights} Nights</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HotelCategoryChoose;
